import React from "react";
import ModalBox from "./component/ModalBox";
import { useState } from "react";

function GradeTable(props) {
  const [box, setBox] = useState(false);
  const [sgpa, setSGPA] = useState(0);
  const { grades, setGrades } = props;

  const getGradePoint = (grade) => {
    if (grade == "A+") {
      return 10;
    } else if (grade == "A") {
      return 9;
    } else if (grade == "B+") {
      return 8;
    } else if (grade == "B") {
      return 7;
    } else if (grade == "C+") {
      return 6;
    } else if (grade == "C") {
      return 5;
    } else if (grade == "D") {
      return 4;
    } else if (grade == "E") {
      return 0;
    } else if (grade == "F") {
      return 0;
    } else if (grade == "I") {
      return 0;
    } else {
      return 0;
    }
  };

  function calculateSGPA() {
    let totalGradePoints = 0;
    let totalCreditHours = 0;
    for (let i = 0; i < grades.length; i++) {
      const grade = grades[i];
      totalGradePoints += getGradePoint(grade.grade) * grade.creditHours;
      totalCreditHours += parseInt(grade.creditHours);
    }
    console.log(totalGradePoints, totalCreditHours);
    return (totalGradePoints / totalCreditHours).toFixed(2);
  }

  function remove(index) {
    let tmpArr = [...grades];
    tmpArr.splice(index, 1);
    setGrades(tmpArr);
  }

  return (
    <div className="tableContainer">
      {box ? <ModalBox box={box} setBox={setBox} sgpa={sgpa} /> : null}
      <table className="fixed_headers">
        <thead>
          <tr>
            <th>Subject Name</th>
            <th>Credit Hours</th>
            <th>Grade</th>
            <th>Remove</th>
          </tr>
        </thead>
        <tbody>
          {grades.map((grade, index) => (
            <tr key={index} className={"tableData"}>
              <td style={{ textAlign: "center" }}>
                {grade.courseName.length > 10
                  ? grade.courseName.slice(0, 8) + "..."
                  : grade.courseName}
              </td>
              <td style={{ textAlign: "center" }}>{grade.creditHours}</td>
              <td style={{ textAlign: "center" }}>{grade.grade}</td>
              <td
                onClick={() => remove(index)}
                style={{ color: "red", cursor: "pointer", textAlign: "center" }}
              >
                {"X"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button
        className="button fixed"
        onClick={() => {
          var s = calculateSGPA();
          setSGPA(s);
          setBox(true);
          // alert(`SGPA: ${calculateSGPA()}`);
        }}
      >
        Calculate SGPA
      </button>
    </div>
  );
}

export default GradeTable;
